module.exports = __webpack_public_path__ + "img/Applet-code.5a35dce4.jpg";